module.exports = __webpack_public_path__ + "img/flag.868a6fe0.svg";